import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from 'components/button';
import HeaderSimple from 'components/header-simple';

import Page from '../page';

import './style.css';

const PageForm = ({
  className,
  children,
  title,
  extra,
  backTo,
  backToText,
  background,
}) => {
  const customClassName = classNames('-page-form', className, {
    '-bg': background,
  });
  return (
    <Page
      className={customClassName}
      header={false}
      footer={false}
      theme="white"
    >
      <HeaderSimple>
        <Button
          hierarchy="tertiary"
          shadow={false}
          href={backTo}
          className="route"
        >
          {backToText}
        </Button>
      </HeaderSimple>
      <div className="page-form-wrapper">
        <section className="page-form">
          <h2 className="page-form-title">{title}</h2>
          {children}
        </section>

        <section className="page-form-extra">{extra}</section>
      </div>
    </Page>
  );
};

PageForm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  backTo: PropTypes.string,
  backToText: PropTypes.string,
  extra: PropTypes.node,
  background: PropTypes.bool,
};

PageForm.defaultProps = {
  className: null,
  children: null,
  extra: null,
  backTo: '',
  backToText: '',
  title: '',
  background: true,
};

export default PageForm;
